import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { GroupService } from '@thiememeulenhoff/ng-api-gateway';
import { User } from '@thiememeulenhoff/types';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

type UsersState = {
  users: Array<User>;
};

const initialState: UsersState = {
  users: [],
};

export const UsersStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withRequestStatus(),
  withMethods((store, groupService = inject(GroupService)) => ({
    fetchUsersByProfileIds: rxMethod<Array<string>>(
      pipe(
        tap(() => patchState(store, { requestStatus: 'loading' })),
        switchMap((tmProfileIds) =>
          groupService.fetchUsersByProfileIds(tmProfileIds).pipe(
            tapResponse({
              next: (users) =>
                patchState(store, { users, requestStatus: 'success' }),
              error: (error: unknown) =>
                patchState(store, {
                  requestStatus: toRequestError(error, 'Failed to fetch users'),
                }),
            }),
          ),
        ),
      ),
    ),
  })),
);
